/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {SpecialCasedStyles as ɵangular_packages_animations_browser_browser_a} from './src/render/special_cased_styles';